import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Card, CardProps, Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../CircledIcon';

export type customCalloutCardProps = CardProps &
  React.PropsWithChildren<{
    cardIcon?: IconProp;
    buttons?: React.ReactNode[];
  }>;

const CalloutCard = ({
  buttons,
  cardIcon,
  children,
}: customCalloutCardProps) => {
  return (
    <Container className="custom-callout-card">
      <Card>
        <Card.Body>
          <Col className="body-col">
            {cardIcon && <Row className="callout-icon">
              <CircledIcon variant="icon-white" icon={cardIcon} />
            </Row>}
            <Container className="text-container">{children}</Container>
            <Col className="btns-col">
              {buttons?.map((button, index) => (
                <Col key={index} className="btn-col">
                  {button}
                </Col>
              ))}
            </Col>
          </Col>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CalloutCard;
